import { MeasuresCatalog } from "@/features/measures/components/MeasuresCatalog";

export function MeasuresPage() {
  return <MeasuresCatalog />;
}
